import script from "./TicketsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsList.vue?vue&type=script&setup=true&lang=js"

import "./TicketsList.vue?vue&type=style&index=0&id=36c5a46c&scoped=true&lang=css"
import "./TicketsList.vue?vue&type=style&index=1&id=36c5a46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c5a46c"]])

export default __exports__